import React, { forwardRef } from 'react'
import MaskedInput from 'react-text-mask'

export default forwardRef(function PhoneNumberMask(props, ref) {
	return (
		<MaskedInput
			{...props}
			ref={ref} // Forward the ref here
			mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
			placeholderChar={'\u2000'}
			guide={false}
		/>
	)
})
